import React, { Component } from "react";
import { Row, Col, Button, Modal, Image } from "react-bootstrap";
import "../../Common/Common.css";
import PDFViewer from 'pdf-viewer-reactjs';

import { appConfig } from "../../../config";

class InvoicePDFView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const InvoiceData = this.props.InvoiceData ? this.props.InvoiceData : null;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.handleClose}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{width:"100%",height:"100vh"}}
      >
        <Modal.Header
            style={{
              fontSize: "35px",
              backgroundColor: "rgb(240, 243, 245)",
              color: "white"
            }}
            closeButton
          ></Modal.Header>
      <Modal.Body>
      {InvoiceData !== null ? (
          <PDFViewer
            document={{
              // url: appConfig.imgServerip+`/getInvImg?imgName=${InvoiceData.data}`,
               url: appConfig.ip+`/attachments/preview/${encodeURIComponent(InvoiceData.data)}`,
            }}
            hideRotation={true}
            navigation={{
              css:{
                navbarWrapper:"navBarClass",
                zoomOutBtn:"zoomOutClass",
                zoomInBtn:"zoomInClass"
              }
            }}
          />
        ) : null}
      </Modal.Body>
      </Modal>
    );
  }
}

export default InvoicePDFView;